// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__20bv1","header":"MergedInvoice_header__QCADy"};